import type { Category } from '@wix/add-panel-common';
import { useContext } from 'react';
import { CurrentCategoryContext } from './CurrentCategoryContext';

export const useCurrentCategory = (): Category => useContext(CurrentCategoryContext).category;
